import { connect } from "react-redux";
import { getToken } from "../../lib";
import * as actions from './actions';
import ProblemReports from "./ProblemReports";

const mapStateToProps = (state, ownProps) => {
  console.log(state);
  return {
    reports: state.problemReports.reports,
    isFetching: state.problemReports.isFetchingList,
    success: state.problemReports.success,
    ...ownProps
  }
}

const mapDispatchToProps = dispatch => ({
  getReports: () => dispatch(actions.getReports(getToken())),
  clearErrors: () => dispatch(actions.clearErrors()),
})

const ProblemReportsContainer = connect(mapStateToProps, mapDispatchToProps)(ProblemReports);

export default ProblemReportsContainer;


// WEBPACK FOOTER //
// src/routes/ProblemReports/ProblemReportsContainer.js